<div class="rs-message">
  <div class="rs-message__header" *ngIf="!headerIsNotVisible">
    <ng-content select="#header"></ng-content>
  </div>
  <div class="rs-message__content">
    <ng-content select="#content"></ng-content>
  </div>
</div>
